import { Skeleton } from '@aimsos/ui';

/**
 * Loading placeholder for `EntityHeader`.
 *
 * Same shape as the loaded header — avatar + title row, then a secondary
 * metadata row — so the swap does not shift the tabs and content below it.
 * No `Card`/`CartContainer` wrapper here either: same rule as the loaded
 * header, the surface belongs to whatever wraps this at the call site.
 */
function EntityHeaderSkeleton({ compact = false }) {
  return (
    <div
      className={['flex w-full flex-col', compact ? 'gap-0' : 'gap-3'].join(' ')}
      data-testid="entity-header-skeleton"
    >
      <div className="flex items-center gap-2">
        <Skeleton width="32px" height="32px" borderRadius="9999px" />
        <Skeleton width="160px" height="20px" borderRadius="4px" />
      </div>
      {/* The compact header has no metadata row, so its skeleton has none
          either — same geometry, so the swap does not shift anything. */}
      {compact ? null : <Skeleton width="45%" height="14px" borderRadius="4px" />}
    </div>
  );
}

export default EntityHeaderSkeleton;
